module.exports = __webpack_public_path__ + "3df0bfde118c94e3a91f3771584856a1.svg";